import { render, staticRenderFns } from "./StaffKPIList.vue?vue&type=template&id=49c98c2c&scoped=true&"
import script from "./StaffKPIList.vue?vue&type=script&lang=js&"
export * from "./StaffKPIList.vue?vue&type=script&lang=js&"
import style0 from "./StaffKPIList.vue?vue&type=style&index=0&id=49c98c2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c98c2c",
  null
  
)

export default component.exports